import React from 'react';
import { Stack } from '@mui/material';

export interface FinancingCardHeaderProps {}

const FinancingCardHeader: React.FC<FinancingCardHeaderProps> = () => {
    return (
        <Stack
            direction="row"
            sx={{ width: 1, flexWrap: 'wrap' }}
            alignItems="center"
            justifyContent="space-between"
        />
    );
};

export default FinancingCardHeader;
